import { h, Component } from 'preact';
import {Button, I18n, Form, Container} from 'components/elements' 
import {PatientSelectCard} from 'components/groups'
import {times} from 'lib/helpers'
import {connect} from 'react-redux'
import style from './style.less'
import { PatientActions } from 'actions';

@Form
@connect((state)=>({
	...state
}))
export default class PatientSelectVertical extends Component {
	constructor(){
        super()
        this.state = {
            newPatient: ''
        }
        this.patientsToCreate = this.patientsToCreate.bind(this)
        this.handleNewPatient = this.handleNewPatient.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
        this.handleNewPatientSubmit = this.handleNewPatientSubmit.bind(this)
        this.handleNewPatientCancel = this.handleNewPatientCancel.bind(this)
    }
    
    get newPatientCount(){
        let newPatientCount = this.patients.filter((patient)=>/newPatient/.test(patient.id)).length
        return newPatientCount
    }

    get patients(){
        return Object.values(this.props.patients || {})
    }

    get patientsReversed() {
        const value = [...this.patients]
        value.reverse()
        return value
    }
    
    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }

    get weightUnit(){
        switch(this.organization.country){
            case "US":
                return I18n.t('lbs')
            case "CA":
                return I18n.t('kg')
            default:
                return I18n.t('lbs')
        }
    }

    get organization(){
        return this.props.organization || {}
    }


    handleNewPatient(e){
        e.preventDefault()
        this.setState({
            newPatient: {}
        })
    }

    handleNewPatientCancel(e){
        e.preventDefault()
        this.setState({
            newPatient: ''
        })
    }

    handleNewPatientSubmit(values){
        this.setState({
            newPatient: ''
        })
        let patient = {
            ...values,
            id: `newPatient-${values.firstName.replace(/ /g, '-')}-${values.lastName.replace(/ /g, '-')}`,
        }

        PatientActions.append(patient)

        this.handlePatientSelect(patient)
    }

    handlePatientSelect(patient){
        this.setState({})
        this.props.onPatientSelect && this.props.onPatientSelect(patient)
    }

    patientsToCreate(){
        let numNewPatients = this.patients.length
        let count = this.props.filters.patientCount - numNewPatients
        if(count <= 0 && this.state.newPatient){
            count = 1
        }
        return count
    }

	render(){
        const {Form, InputDark, SelectDark, FormData} = this.props

		return (
            <div>
                {(this.patientsToCreate() > 0 || this.newPatient) ?
                    <div>
                        {times(this.patientsToCreate()).map((i)=>{
                            return (
                                <div key={`new-patient-container-${this.newPatientCount + i}`}>
                                    <Form onSubmit={this.handleNewPatientSubmit}>
                                        <InputDark 
                                            required={true} 
                                            name='firstName' 
                                            type='text' 
                                            question='First Name' 
                                            class={style.newPatientField} 
                                            initialValue={''}
                                        />
                                        <InputDark 
                                            required={true} 
                                            name='lastName' 
                                            type='text' 
                                            question='Last Name' 
                                            class={style.newPatientField} 
                                            initialValue={''}
                                        />
                                        <div class={style.newPatientButtonContainer}>
                                            {this.patientsToCreate() == 0 &&
                                                <Button onClick={this.handleNewPatientCancel}>Cancel</Button>
                                            }
                                            <Button >Submit</Button>
                                        </div>
                                    </Form>
                                </div>
                            )
                        })}
                    </div>
                :
                    <div key="new-patient-prompt" class={style.newPatient} onClick={this.handleNewPatient}>
                        + <I18n>addNewPet</I18n>
                    </div>
                }
                
                {this.patientsReversed.map((patient, i)=>{
                    const selected = Object.keys(this.props.selectedPatients).indexOf(patient.id) != -1
                    return (
                        <PatientSelectCard 
                            {...patient}
                            selected={!!selected}
                            genericPatients={this.props.config.genericPatients}
                            onSelect={this.handlePatientSelect.bind(null, patient)} 
                        />
                    )
                })}
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientSelect/GenericPatientSelectVertical.js